<h2>Thanks for your registration {{user.knownAs | titlecase}}!</h2>
After we have approved your registration we will send you a confirmation email. <br/><br/>

Click <a routerLink='/' >here</a> to go back to the login page.
